import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { RootLayout } from "./RootLayout";
import {
  CompletedControlSurveyRoute,
  RedirectControlSurveyRoute,
} from "./routeElements";
import { BaseTenantLayout, OrgTenantLayout } from "./tenantLayouts";
import AppBootstrap from "../AppBootstrap";
import { sharedRoutes } from "./sharedRoutes";
import useTenant from "../tenancy/useTenantPath";

const TenantHomeRedirect = () => {
  const tenant = useTenant();

  return <Navigate to={tenant.basePath} replace />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: "redirect-control-survey",
        element: <RedirectControlSurveyRoute />,
      },
      {
        path: "completed-control-survey",
        element: <CompletedControlSurveyRoute />,
      },

      {
        element: <BaseTenantLayout />,
        children: [
          {
            element: <AppBootstrap />,
            children: [
              ...sharedRoutes(),
              {
                path: "*",
                element: <TenantHomeRedirect />,
              },
            ],
          },
        ],
      },

      {
        path: ":orgSlug",
        element: <OrgTenantLayout />,
        children: [
          {
            element: <AppBootstrap />,
            children: [
              ...sharedRoutes(),
              {
                path: "*",
                element: <TenantHomeRedirect />,
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
